import styles from './NoDataAndLoading.css'
import {Link} from 'react-router'

class NoDataAndLoading extends React.Component {
  render () {
    let {showLoadingSpinner, noDataToDisplay, title, description, footerElement, image, loadingDescription, loadingDescriptionAfterChangeMenu, linkLabel, linkUrl, halfHeight} = this.props
    let heightClass = 'full-height-no-data-display'
    if (halfHeight) {
      heightClass = 'half-height-no-data-display'
    }
    return (
      <div className={`${showLoadingSpinner || noDataToDisplay ? 'col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding ' + styles['parent-box-data-display'] : ''} `}>
        {showLoadingSpinner &&
        <div className={heightClass}>
          <div className={`${styles['loading-container']} box-spinner`}>
            <div className={`${styles['content-loading-spinner']}`}>
              <img src={require('assets/images/loading-simple.gif')} alt='mokapos spinner' className={styles['loading-spinner']} />
              {loadingDescription !== undefined && <div className={styles.description}><p>{loadingDescription}</p></div>}
            </div>
          </div>
        </div>}
        {loadingDescriptionAfterChangeMenu !== undefined && loadingDescriptionAfterChangeMenu}
        {noDataToDisplay && !showLoadingSpinner &&
        <div className={heightClass}>
          <div className={`${styles['no-data-container']} box-spinner`}>
            <div className={`${styles['content-no-data-display']}`}>
              <div>
                <img src={image}
                  className={styles.img}
                  alt='no sales'
                  width='110px'
                    />
              </div>
              <div>
                <h3 className={styles['title']}>{title}</h3>
              </div>
              <div className={styles.description}>
                <p>
                  {description}
                </p>
                {linkLabel && linkUrl &&
                  <p>
                    Learn more about &nbsp;
                    <Link
                      to={linkUrl}
                      className={styles['link-knowledge-center']}
                      target='_blank'>{linkLabel}
                    </Link>
                  </p>}
              </div>
              {!!footerElement && footerElement}
            </div>
          </div>
        </div>
          }
      </div>
    )
  }
}

NoDataAndLoading.propTypes = {
  showLoadingSpinner: React.PropTypes.bool,
  noDataToDisplay: React.PropTypes.bool,
  title: React.PropTypes.string,
  description: React.PropTypes.string,
  footerElement: React.PropTypes.object,
  image: React.PropTypes.string,
  linkLabel: React.PropTypes.string,
  linkUrl: React.PropTypes.string
}

NoDataAndLoading.defaultProps = {
  image: require('assets/images/backoffice/no-transaction.png')
}

export default NoDataAndLoading



// WEBPACK FOOTER //
// ./app/components/NoDataAndLoading/NoDataAndLoading.js